import { locationHistory, previousAlerts } from './detail-notification'

export const dataDemoAdas = [
  {
    rawAlertId: 10,
    createdOn: '2024-06-12T07:13:25.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 35480,
      vehicleType: {
        type: '1.3 D Face Face',
        model: 'Granmax MB',
        category: 'Mini Bus',
        icon: 'bus',
        __typename: 'VehicleType',
      },
      device: {
        deviceCode: 6001,
      },
      imei: '864993060037652',
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      __typename: 'Vehicle',
    },
    alertCode: 92,
    alert: {
      alertCode: 92,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      descriptionEng: 'Lane Departure Warning',
      descriptionIdn: 'Lane Departure Warning',
      alertCategories: [{ alertCategoryId: 4 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    alertData: 'ADAS_BSJ_Keluar_Jalur_02_64_6402_00_1717913900166.mp4',
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: null,
    threshold: '',
    locationHistory,
    previousAlerts,
    media: [
      {
        downloadId: 1,
        mediaFilename: 'ADAS_BSJ_Keluar_Jalur_02_64_6402_00_1717913900166.mp4',
        channel: 1,
        status: 'S',
        identifier: 'V',
      },
    ],
    mediaStatus: 'Success',
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 11,
    createdOn: '2024-06-12T07:12:25.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 35480,
      vehicleType: {
        type: '1.3 D Face Face',
        model: 'Granmax MB',
        category: 'Mini Bus',
        icon: 'bus',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '864993060037652',
      __typename: 'Vehicle',
    },
    alertCode: 91,
    alert: {
      alertCode: 91,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',

      descriptionEng: 'Headway Monitoring Warning',
      descriptionIdn: 'Headway Monitoring Warning',
      alertCategories: [{ alertCategoryId: 4 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    alertData: 'ADAS_BSJ_Jarak_Aman_02_64_6403_00_1717913744018.mp4',
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: null,
    threshold: '',
    locationHistory,
    previousAlerts,
    media: [
      {
        downloadId: 1,
        mediaFilename: 'ADAS_BSJ_Jarak_Aman_02_64_6403_00_1717913744018.mp4',
        channel: 1,
        status: 'S',
        identifier: 'V',
      },
    ],
    mediaStatus: 'Success',
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 12,
    createdOn: '2024-06-12T07:11:25.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 35480,
      vehicleType: {
        type: '1.3 D Face Face',
        model: 'Granmax MB',
        category: 'Mini Bus',
        icon: 'bus',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '864993060037652',
      __typename: 'Vehicle',
    },
    alertCode: 90,
    alert: {
      alertCode: 90,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      descriptionEng: 'Forward Collision Warning',
      descriptionIdn: 'Forward Collision Warning',
      alertCategories: [{ alertCategoryId: 4 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    alertData: 'ADAS_BSJ_Benturan_Depan_02_64_6401_00_1717912658808.mp4',
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: null,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    media: [
      {
        downloadId: 1,
        mediaFilename: 'ADAS_BSJ_Benturan_Depan_02_64_6401_00_1717912658808.mp4',
        channel: 1,
        status: 'S',
        identifier: 'V',
      },
    ],
    mediaStatus: 'Success',
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 13,
    createdOn: '2024-06-12T07:13:25.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'Demo Mining',
      id: 35480,
      vehicleType: {
        type: '1.3 D Face Face',
        model: 'Granmax MB',
        category: 'Mini Bus',
        icon: 'bus',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '864993060037652',
      __typename: 'Vehicle',
    },
    alertCode: 96,
    alert: {
      alertCode: 96,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      descriptionEng: 'Potential Collision',
      descriptionIdn: 'Potensi Benturan',
      alertCategories: [{ alertCategoryId: 4 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    alertData: 'demo-potensi-benturan.mp4',
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: null,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    media: [
      {
        downloadId: 1,
        mediaFilename: 'demo-potensi-benturan.mp4',
        channel: 1,
        status: 'S',
        identifier: 'V',
      },
    ],
    mediaStatus: 'Success',
    __typename: 'RawAlert',
  },
]
